import { createContext, useContext } from 'react';
export var UIContext = /*#__PURE__*/createContext(undefined);
export var useUIContext = function useUIContext() {
  var context = useContext(UIContext);
  if (context === undefined) {
    throw new Error('useUIContext must be used within a UIProvider component');
  }
  return context;
};